import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import promiseMiddleware from 'redux-promise-middleware';
import logger from 'redux-logger';
import { I18nextProvider } from 'react-i18next';
import { languageChange } from 'i18next-redux-languagedetector';
import configureI18n from './i18n';
import { msalConfig } from './authConfig';
import App from './App';
import reportWebVitals from './reportWebVitals';
import reducer from './reducers';
import 'bootstrap/dist/css/bootstrap.min.css';
import './scss/index.scss';
import LandingPageSpinner from './Components/common/Skeletons/LandingPageSpinner';

const vh = () => window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh()}px`);

const i18nextConfig = {
  language: null
};

const msalInstance = new PublicClientApplication(msalConfig);

const middlewares = [thunk, promiseMiddleware];
if (process.env.NODE_ENV === 'development') {
  middlewares.push(logger);
}

const store = createStore(reducer, composeWithDevTools(applyMiddleware(...middlewares)));

const i18n = configureI18n({
  i18nextConfig,
  redux: {
    lookupRedux() {
      // return store.getState().i18next;
    },
    cacheUserLanguageRedux(language) {
      store.dispatch(languageChange(language));
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <MsalProvider instance={msalInstance}>
    <Provider store={store}>
      <I18nextProvider i18n={i18n}>
        <Suspense fallback={<LandingPageSpinner />}>
          <App msalInstance={msalInstance} />
        </Suspense>
      </I18nextProvider>
    </Provider>
  </MsalProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
